import { Application } from "./application";
import { SystemField } from "./system-field";

export class AppModule extends SystemField{
    name?:string;
    applications_id?:string;

    //relationship
    application?:Application;
}
